// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"C9-z","button":"D9-z","disabled":"E9-z","creditCard":"F9-z","wrapper":"G9-z"};